import styled, { css } from 'styled-components';
import mq from '../../../utils/mediaQueries.js';

// @ts-nocheck
var LolloBernie = styled.img.withConfig({
  displayName: "LolloBerniestyle__LolloBernie",
  componentId: "sc-1kbu3fh-0"
})(["display:none;height:80px;", ""], mq.s(css(["display:block;"])));

export { LolloBernie };
//# sourceMappingURL=LolloBernie.style.js.map
